import React from 'react'
import axios from 'axios'
import InputMask from 'react-input-mask'

import Cidades from '../Cidades/Cidades.js'

import Cabecalho from '../Cabecalho/Cabecalho'
import Processo from '../Form/ProcessoNovo'
import Obs from '../Form/Obs'
import Button from '../Form/Button'

export default class NovoEstabelecimento extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                cpfCnpj: '', estado: localStorage.estado, data: '', estabelecimento: '', fantasia: '', registro: '',
                endereco: '', municipio: '',
                uf: '', cep: '', telefone: '', fechadoObs: '',
                nome: localStorage.nome, matricula: localStorage.matricula
            },
            municipios: []
        }
    }

    componentDidMount() {
        if(localStorage.tipo !== "interno") {
            window.location = '/'
        }
        const id = this.props.match.params.id
        const url = `/api/paf/getCpf/${id}`
        axios(url)
            .then(resp => {
                this.setState({ ficha: resp.data })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error)
            })
    }

    save(e) {
        e.preventDefault()
        const url = '/api/paf/editEstabelecimento'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert(res.data)
                window.location = `/buscaEstabelecimento`
            })
            .catch(error => {
                alert(error)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    renderTipo() {
        if (this.state.ficha.cpfCnpj.length < 15) {
            return (
                <React.Fragment>
                    <label className="col-2">CPF:</label>
                    <div className="col-4">
                        <InputMask type="text" className="form-control"
                            mask="999.999.999-99"
                            name="cpfCnpj"
                            onChange={e => this.updateField(e)}
                            value={this.state.ficha.cpfCnpj} />
                    </div>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <label className="col-2">CNPJ:</label>
                    <div className="col-4">
                        <InputMask type="text" className="form-control"
                            mask="99.999.999/9999-99"
                            name="cpfCnpj"
                            onChange={e => this.updateField(e)}
                            value={this.state.ficha.cpfCnpj} />
                    </div>
                </React.Fragment>
            )
        }
    }

    render() {
        if (this.state.loaded) {
            let ano = this.state.ficha.createdAt.slice(0, 4)
            let mes = this.state.ficha.createdAt.slice(5, 7)
            let dia = this.state.ficha.createdAt.slice(8, 10)
            let data = dia + "/" + mes + "/" + ano
            return (
                <React.Fragment>
                    <div className="container">
                        <Cabecalho />
                        <div className="form-group row mt-3 text-left">
                            {this.renderTipo()}
                            <div className="col-12"></div>
                            <label className="col-3 col-md-2">Data:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    name="data"
                                    value={data} />
                            </div>
                            <label className="col-4 col-md-2">Estabelecimento:</label>
                            <div className="col-8 col-md-6 mb-3">
                                <input type="text" className="form-control"
                                    name="estabelecimento"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.estabelecimento} />
                            </div>
                        </div>
                        <Button onClick={e => this.save(e)} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderMunicipios() {
        let select = []
        this.state.municipios.map(municipio => {
            select.push(<option value={municipio.nome}>{municipio.nome}</option>)
        })
        return select
    }
}